import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add",
  "use": "add-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"add\">\n<path d=\"M9.75 1.5H8.25V8.25H1.5V9.75H8.25V16.5H9.75V9.75H16.5V8.25H9.75V1.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol